import { Bar, BarChart, Brush, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { convertDate, renderColorfulLegendText } from "../../util/Util";

const TemChart = ({ chartData, type, startYear, endYear }) => {

    return (
        <>
            {type === "5 Years" ?
                <ResponsiveContainer width={"100%"} height="100%">
                    <BarChart
                        data={chartData}
                        margin={{ top: 25, right: 30, bottom: 35 }}
                    >
                        <CartesianGrid strokeDasharray="0.5 0.5" />
                        <XAxis
                            angle={45}
                            textAnchor="start"
                            dataKey="dayMonth"
                            stroke="rgba(255,255,255,1)"
                            type="category"
                            allowDuplicatedCategory={false}
                        />

                        <YAxis unit=" °C"
                            type="number"
                            domain={["0", "dataMax + 100"]}
                            stroke="white" />
                        <Tooltip cursor={{ fill: 'transparent' }}
                            wrapperStyle={{ color: "rgba(1, 28, 20, 0.74)" }}
                            itemStyle={{ color: "rgba(1, 28, 20, 0.74)" }}
                        />
                        <Legend verticalAlign="top"

                            height={50} />

                        {chartData.map((eachSegment, key) => (
                            <Bar
                                fillOpacity={1}
                                type="monotone"
                                dataKey="max_temperature"
                                height={50}
                                data={eachSegment?.data}
                                key={`Max${key}`}
                                name={`Max ${eachSegment?.year}`}
                                stroke={eachSegment?.color}
                                fill={eachSegment?.color}
                            />
                        ))}

                        {chartData.map((eachSegment, key) => (
                            <Bar
                                fillOpacity={1}
                                type="monotone"
                                dataKey="min_temperature"
                                height={50}
                                data={eachSegment?.data}
                                key={`Min${key}`}
                                name={`Min ${eachSegment?.year}`}
                                stroke={eachSegment?.color}
                                fill={eachSegment?.color}
                            />
                        ))}

                        <Brush
                            dataKey="dayMonth"
                            height={20}
                            stroke="blue"
                            y={400}
                            data={chartData}
                            gap={20}
                            style={{ marginTop: "20em" }}
                            travellerWidth={50}
                        />
                    </BarChart>
                </ResponsiveContainer>
                :
                <>
                    {type === "None" ?
                        <ResponsiveContainer
                            debounce={5}
                            width={"100%"}
                            height="100%"
                        >
                            <BarChart
                                data={chartData}
                                margin={{ top: 15, right: 30, left: 20, bottom: 35 }}
                            >
                                <CartesianGrid strokeDasharray="1 1" />
                                <XAxis
                                    tickFormatter={convertDate}
                                    angle={45}
                                    textAnchor="start"
                                    dataKey="date"
                                    stroke="white"
                                />
                                <YAxis
                                    unit=" °C"
                                    type="number"
                                    domain={["0", "dataMax + 100"]}
                                    stroke="white"
                                />
                                <Tooltip cursor={{ fill: 'transparent' }}
                                    wrapperStyle={{ color: "rgba(1, 28, 20, 0.74)" }}
                                    itemStyle={{ color: "rgba(1, 28, 20, 0.74)" }}
                                />
                                <Legend
                                    verticalAlign="top"
                                    formatter={() =>
                                        renderColorfulLegendText(
                                            "Max/Min Temperature - " + startYear + endYear,
                                            "white"
                                        )
                                    }
                                    height={50}
                                />

                                <Brush
                                    dataKey="date"
                                    height={20}
                                    stroke="blue"
                                    // x={0}
                                    y={400}
                                    data={chartData}
                                    gap={20}
                                    style={{ marginTop: "20em" }}
                                    travellerWidth={50}
                                />

                                <Bar
                                    name="Max Temperature"
                                    fillOpacity={1}
                                    type="monotone"
                                    dataKey="max_temperature"
                                    stroke="white"
                                    fill="#2F7A64"
                                    height={50}
                                />
                                <Bar
                                    name="Min Temperature"
                                    fillOpacity={1}
                                    type="monotone"
                                    dataKey="min_temperature"
                                    stroke="#6CADEA"
                                    fill="#6CADEA"
                                    height={50}
                                />
                            </BarChart>
                        </ResponsiveContainer>
                        : <ResponsiveContainer
                            debounce={5}
                            width={"100%"}
                            height="100%"
                        >
                            <BarChart
                                data={chartData}
                                margin={{ top: 15, right: 30, left: 20, bottom: 35 }}
                            >
                                <CartesianGrid strokeDasharray="1 1" />
                                <XAxis
                                    angle={45}
                                    textAnchor="start"
                                    dataKey="dayMonth"
                                    stroke="white"
                                />
                                <YAxis
                                    unit=" °C"
                                    type="number"
                                    domain={["0", "dataMax + 100"]}
                                    stroke="white"
                                />
                                <Tooltip cursor={{ fill: 'transparent' }}
                                    wrapperStyle={{ color: "rgba(1, 28, 20, 0.74)" }}
                                    itemStyle={{ color: "rgba(1, 28, 20, 0.74)" }}
                                />
                                <Legend
                                    verticalAlign="top"
                                    formatter={() =>
                                        renderColorfulLegendText(
                                            "Average Max/Min Temperature - " + startYear + endYear,
                                            "white"
                                        )
                                    }
                                    height={50}
                                />

                                <Brush
                                    dataKey="dayMonth"
                                    height={20}
                                    stroke="blue"
                                    // x={0}
                                    y={400}
                                    data={chartData}
                                    gap={20}
                                    style={{ marginTop: "20em" }}
                                    travellerWidth={50}
                                />

                                <Bar
                                    name="Max Temperature"
                                    fillOpacity={1}
                                    type="monotone"
                                    dataKey="max_temperature"
                                    stroke="white"
                                    fill="#2F7A64"
                                    height={50}
                                />
                                <Bar
                                    name="Min Temperature"
                                    fillOpacity={1}
                                    type="monotone"
                                    dataKey="min_temperature"
                                    stroke="#6CADEA"
                                    fill="#6CADEA"
                                    height={50}
                                />
                            </BarChart>
                        </ResponsiveContainer>}
                </>
            }
        </>
    )
};

export default TemChart;